module.exports = __webpack_public_path__ + "static/media/PSCircle.ba0db53c.svg";